/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Page Footer.
 */

import React from "react";
import {useAuth0} from "@auth0/auth0-react";
import { releaseAndLogout } from "../../../utils/logout";

export const PageFooter = () => {
    const {
        user,
        isAuthenticated,
        loginWithRedirect,
        logout,
    } = useAuth0();

    const logoutWithRedirect = () => releaseAndLogout(logout);

    return (
        <footer style={{
            backgroundColor: "#343a40",
            color: "white",
            padding: "16px 24px",
            fontSize: "12px",
            lineHeight: "1.4",
            textAlign: "center",
            // position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000
        }}>
            
            <div style={{
            	maxWidth: "640px",
            	margin: "0 auto"
            }}>
                Copyright © Farelanes LLC. All rights reserved. "MyFarelanes" and the Farelanes logo are trademarks or service mark of Farelanes LLC and may not be used or reproduced without prior written permission. &nbsp;fl-3.1.0
            </div>
        </footer>
    );
};